import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Stack,
} from "@mui/material";

import pickupbyotp from "../../assets/pickupbyotp.png";
import swipe from "../../assets/swipe.png";
import gonext from "../../assets/gonext.png";
import Header from "./Header";

const PickupOptions = () => {
  const navigate = useNavigate();
  const { orderId } = useParams();

  return (
    <>
      <Header handleBack={() => navigate("/")} />

      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#f5f6fa",
          px: { xs: 2, sm: 3, md: 4 },
          pt: { xs: 10, md: 12 },
          pb: 4,
        }}
      >
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 600,
            mb: 3,
            color: "#333",
          }}
        >
          2 Pickup Options – Choose What Works Best For You
        </Typography>

        <Stack
          direction={{ xs: "column", lg: "row" }}
          spacing={{ xs: 2, md: 3 }}
          alignItems="center"
          justifyContent="center"
        >
          {/* Card 1 */}
          <Card
            onClick={() => navigate(`/activeOrder/false/${orderId}`)}
            sx={{
              width: {
                xs: "100%",
                sm: "420px",
                md: "380px",
                lg: "450px",
              },
              borderRadius: 3,
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              "&:hover": {
                transform: "translateY(-2px)",
              },
            }}
          >
            <CardMedia
              component="img"
              image={pickupbyotp}
              alt="pickup"
              sx={{
                width: "100%",
                height: {
                 /*  xs: 180,
                  sm: 220,
                  md: 220,
                  lg: 300, */
                },
                objectFit: "contain",
                p: 2,
              }}
            />

            <CardContent
              sx={{
                py: 1,
                "&:last-child": {
                  pb: 1,
                },
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Vend By Entering Code On Kiosk
                </Typography>

                <Box
                  component="img"
                  src={gonext}
                  alt="next"
                  sx={{
                    width: 14,
                  }}
                />
              </Box>
            </CardContent>
          </Card>

          {/* OR */}
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              color: "#000",
            }}
          >
            OR
          </Typography>

          {/* Card 2 */}
          <Card
            onClick={() => navigate(`/activeOrder/true/${orderId}`)}
            sx={{
              width: {
                xs: "100%",
                sm: "420px",
                md: "380px",
                lg: "450px",
              },
              borderRadius: 3,
              cursor: "pointer",
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              "&:hover": {
                transform: "translateY(-2px)",
              },
            }}
          >
            <CardMedia
              component="img"
              image={swipe}
              alt="swipe"
              sx={{
                width: "100%",
                height: {
                 /*  xs: 180,
                  sm: 220,
                  md: 220,
                  lg: 300, */
                },
                objectFit: "contain",
                p: 2,
              }}
            />

            <CardContent
              sx={{
                py: 1,
                "&:last-child": {
                  pb: 1,
                },
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                  }}
                >
                  Vend By Swiping On App
                </Typography>

                <Box
                  component="img"
                  src={gonext}
                  alt="next"
                  sx={{
                    width: 14,
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </>
  );
};

export default PickupOptions;